import { configureStore } from '@reduxjs/toolkit';
import cartReducer from './cartSlice';

/**
 * Redux store for the POS app.
 * Slices: cart (items, customer, discounts).
 */
const store = configureStore({
  reducer: {
    cart: cartReducer,
  },
});

export default store;
